
define('app/join/views/joinView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'unknown/models/loginModel',
	'unknown/models/registerModel',
	'known/models/leagueInstanceModel',
	'known/collections/leagueInstanceCollection',
	
	//Shims
	'jquery.collapsible',
	'jquery.sha256'
], function($, _, Backbone, UserModel, LoginModel, RegisterModel, LeagueInstanceModel, LeagueInstanceCollection){
	
	//Models
	var SearchLeagueModel = Backbone.Model.extend({	
		urlRoot: "/draftapp/leagues/search",
		defaults: {
			id: null,
			key: null,
	    },

	    initialize: function() {
	    	
	    }
	});

	var JoinLeagueInstanceModel = Backbone.Model.extend({
		defaults: {
			leagueInstanceId: null,
			teamId: null,
			name: null, //team name
			userName: null,
			key: null,
	    },
	    
	    urlRoot: function() {
	    	return '/draftapp/users/' + this.get("userName") + '/leagues/';
		},

		initialize: function() {
			
	    }
	});
	
	//Views
	var JoinFooterView = Backbone.View.extend({
		events: {
			'click #joinLgFormSubmit': 'submitForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			this.userModel = options.userModel;
			
			this.showForm();
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'saving', this.showNonForm);
			this.listenTo(this.event, 'leagueClosed', this.showForm);
			this.listenTo(this.event, 'alreadyInLeague', this.showNonForm);
			this.listenTo(this.event, 'success', this.showNonForm);
			this.listenTo(this.event, 'errorLogin', this.showForm);
			this.listenTo(this.event, 'errorSearchLg', this.showForm);
			this.listenTo(this.event, 'errorJoinLgInst', this.showForm);
			this.listenTo(this.event, 'errorLogin:notAuthorized', this.showForm);
		},
		
		submitForm: function () {
			this.event.trigger("save");
		},
		
		showForm: function () {
			this.$("#joinLgSubmitFooter").show();
			
			//TODO: Remove once a better solution is found
			if(this.userModel.isGuest()){
				this.$("#joinLgSubmitFooter").hide();
			}
		},
		
		showNonForm: function () {
			this.$("#joinLgSubmitFooter").hide();
		},
	});

	var JoinContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.userModel = options.userModel;
			this.leagueModel = options.leagueModel;
			this.loginModel = options.loginModel;
			this.registerModel = options.registerModel;
			this.searchLgModel = options.searchLgModel,
			this.joinLgModel = options.joinLgModel,
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successJoinCallback');
			_.bindAll(this, 'errorJoinCallback');
			_.bindAll(this, 'successSearchCallback');
			_.bindAll(this, 'errorSearchCallback');
			_.bindAll(this, 'successLoginCallback');
			_.bindAll(this, 'errorLoginCallback');
			_.bindAll(this, 'loginTypeChange');
			_.bindAll(this, 'updateTeamTextInput');			
			
			this.listenTo(this.event, 'save', this.submitData);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'alreadyInLeague', this.alreadyJoined);
			this.listenTo(this.event, 'leagueClosed', this.form);
			this.listenTo(this.event, 'success', this.success);
			this.listenTo(this.event, 'errorLogin', this.form);
			this.listenTo(this.event, 'errorSearchLg', this.form);
			this.listenTo(this.event, 'errorJoinLgInst', this.form);
			this.listenTo(this.event, 'errorLogin:notAuthorized', this.form);
			
			//Error handling
			this.listenTo(this.event, 'errorSearchLg:key', this.errorLeagueKey);
			this.listenTo(this.event, 'errorJoinLgInst:teamid', this.errorTeam);
			this.listenTo(this.event, 'errorJoinLgInst:teamname', this.errorTeamName);
			this.listenTo(this.event, 'errorLogin:logintype', this.errorLoginType);
			this.listenTo(this.event, 'errorLogin:username', this.errorUsername);
			this.listenTo(this.event, 'errorLogin:password', this.errorPassword);
			this.listenTo(this.event, 'errorLogin:email', this.errorEmail);
			
			this.listenTo(this.userModel, 'change:userName', this.form);
						
			this.$("input[name='joinLgLoginType']").change(this.loginTypeChange);  
		},
		
		submitData: function() {
			if(this.userModel.isGuest()){
				this.submitLogin();
			}
			
			if(this.leagueModel.isNew()){
				this.submitSearch();
			} else {
				this.submitJoinLg();
			}
		},
		
		submitJoinLg: function() {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				this.submittedData.isSubmitted = true;
				
				this.joinLgModel.save({
					userName: this.userModel.get('userName'),
					leagueInstanceId : this.leagueModel.get('id'),
					teamId: this.$("#joinLgInfoPickTmInput").val(),
					teamName: this.$("#joinLgInfoTmNameInput").val(),
					key: this.searchLgModel.get('key') ? this.searchLgModel.get('key') : $.urlParam('key')
				},{wait: true,
					success : this.successJoinCallback, 
					error : this.errorJoinCallback
				});
			}
		},
		
		submitSearch: function() {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				this.submittedData.isSubmitted = true;
				
				this.searchLgModel.save({
					key: this.$("#joinLgSearchKeyInput").val()
				},{wait: true,
					success : this.successSearchCallback, 
					error : this.errorSearchCallback
				});
			}
		},
		
		submitLogin: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				if(this.$("input[name='joinLgLoginType']:checked").val() == 'LOGIN'){
					//Attempt to login user
					this.submittedData.isSubmitted = true;
					
					this.loginModel.save({
						userName: this.$("#joinLgLoginUserNameInput").val(),
						password : this.$("#joinLgLoginPassInput").val() ? $.sha256(this.$("#joinLgLoginPassInput").val()) : ""
					},{wait: true,
						success : this.successLoginCallback, 
						error : this.errorLoginCallback
					});
				} else if(this.$("input[name='joinLgLoginType']:checked").val() == 'REGISTER'){
					//Attempt to register user
					var submittable = false;
					var username = this.$("#joinLgLoginUserNameInput").val();
					var email = this.$("#joinLgLoginEmailInput").val();
					
					if(this.$("#joinLgLoginPassInput").val()){
						if(this.$("#joinLgLoginPassInput").val() == username){
							this.event.trigger("error");
							this.event.trigger("error:password", "SAME");
						} else if (this.$("#joinLgLoginPassInput").val().length < 5) {
							this.event.trigger("error");
							this.event.trigger("error:password", "LENGTH");
						} else {
							submittable = true;
						} 
					} else {
						submittable = true;
					}
										
					if(submittable){
						this.submittedData.isSubmitted = true;
						this.registerModel.save({
							userName: username,
							password : this.$("#joinLgLoginPassInput").val() ? $.sha256(this.$("#joinLgLoginPassInput").val()) : "",
							email: email
						},{wait: true,
							success : this.successLoginCallback, 
							error : this.errorLoginCallback
						});	
					}
				} else {
					//problem with the radio input
					this.event.trigger("error");
					this.event.trigger("error:logintype", "NULL");
				}
			}
		},
		
		successJoinCallback: function(model, response) {
			this.event.trigger("savingJoinSuccess", model, response);
		},
		
		errorJoinCallback: function(model, error) {
			this.event.trigger("savingJoinError", model, error);
		},
		
		successSearchCallback: function(model, response) {
			this.event.trigger("savingSearchSuccess", model, response);
		},
		
		errorSearchCallback: function(model, error) {
			this.event.trigger("savingSearchError", model, error);
		},
		
		successLoginCallback: function(model, response) {
			this.event.trigger("savingLoginSuccess", model, response);
		},
		
		errorLoginCallback: function(model, error) {
			this.event.trigger("savingLoginError", model, error);
		},
		
		loginTypeChange: function() {
			if (this.$("input[name='joinLgLoginType']:checked").val() == 'LOGIN') {
				this.$("#joinLgLoginEmailGrp").hide();
			} else if (this.$("input[name='joinLgLoginType']:checked").val() == 'REGISTER') {
				this.$("#joinLgLoginEmailGrp").show();
			} else {
				this.$("#joinLgLoginEmailGrp").hide();
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#joinLgSuccessGrp").hide();
			this.$("#joinLgAlreadyJoinedGrp").hide();
			
			this.$("#joinLgInfoLgNameGrp").hide();
			this.$("#joinLgInfoCommishNameGrp").hide();
			this.$("#joinLgInfoPickTmGrp").hide();
			this.$("#joinLgInfoTmNameGrp").hide();
			this.$("#joinLgSearchKeyGrp").hide();
			this.$("#joinLgLoginTypeGrp").hide();
			this.$("#joinLgLoginUserNameGrp").hide();
			this.$("#joinLgLoginPassGrp").hide();
			this.$("#joinLgLoginEmailGrp").hide();
			
			//Hide error messages
			this.$("#joinLgSearchKeyGrp").removeClass("error");
			this.$("#joinLgSearchKeyInput").removeClass("error");
			this.$("#joinLgSearchKeyErrMsg").hide();
			
			this.$("#joinLgInfoPickTmGrp").removeClass("error");
			this.$("#joinLgInfoPickTmErrMsg").hide();
			
			this.$("#joinLgInfoTmNameGrp").removeClass("error");
			this.$("#joinLgInfoTmNameInput").removeClass("error");
			this.$("#joinLgInfoTmNameErrMsg").hide();			
			
			this.$("#joinLgLoginTypeGrp").removeClass("error");
			this.$("#joinLgLoginTypeErrMsg").hide();
			
			this.$("#joinLgLoginUserNameGrp").removeClass("error");
			this.$("#joinLgLoginUserNameInput").removeClass("error");
			this.$("#joinLgLoginUserNameErrMsg").hide();
			
			this.$("#joinLgLoginPassGrp").removeClass("error");
			this.$("#joinLgLoginPassInput").removeClass("error");
			this.$("#joinLgLoginPassErrMsg").hide();
			
			this.$("#joinLgLoginEmailGrp").removeClass("error");
			this.$("#joinLgLoginEmailInput").removeClass("error");
			this.$("#joinLgLoginEmailErrMsg").hide();
		},
		
		form: function () {
			this.hideAll();
			
			if(this.userModel.isGuest()){
				//this.loginTypeChange();
				//this.loginForm();
				
				//TODO: remove this stuff once we figure out better solution...
				this.lgInfoForm();
				var notSignedInWarning = $('<div class="alert alert-warning margin"><strong>You are not signed in.</strong><p>Please <a href="https://clickydraft.com/draftapp/users">register</a> for an account or <a href="https://clickydraft.com/draftapp/auth">login</a> before joining your league</p></div>');
				this.$("#joinLgInfoCommishNameGrp").after(notSignedInWarning);
				this.$("#joinLgInfoPickTmGrp").hide();
				this.$("#joinLgInfoTmNameGrp").hide();
				this.$("#joinLgLoginTypeGrp").hide();
				this.$("#joinLgLoginUserNameGrp").hide();
				this.$("#joinLgLoginPassGrp").hide();
				$("#joinLgSubmitFooter").hide();
				$("#sideNavLoginReg").hide();
				
			} else {
				//TODO: Place outside of else condition once we figure out better solution
				if(this.leagueModel.isNew()){
					this.searchForm();
				} else {
					this.lgInfoForm();
				}	
			}
			
					
			
			$(this.el).show();
		},
		
		lgInfoForm: function() {
			if(!this.lgRendered){
				this.lgRendered = true;
				
				this.$("#joinLgInfoNameLabel").html(this.leagueModel.prettyDispName());
				this.$("#joinLgInfoCommishLabel").html(this.leagueModel.getCommisssionerUser().prettyDispName());
				this.populateProdDropdown();
			}
			
			this.$("#joinLgInfoLgNameGrp").show();
			this.$("#joinLgInfoCommishNameGrp").show();
			this.$("#joinLgInfoPickTmGrp").show();
			this.$("#joinLgInfoTmNameGrp").show();
		},
		
		loginForm: function() {
			this.$("#joinLgLoginTypeGrp").show();
			this.$("#joinLgLoginUserNameGrp").show();
			this.$("#joinLgLoginPassGrp").show();
		},
		
		searchForm: function() {
			this.$("#joinLgSearchKeyGrp").show();
		},
		
		populateProdDropdown: function () {
			var commishTeams = this.leagueModel.getUserTeams(this.leagueModel.getCommisssionerUser().get('userName'));
			var selectableTeams = _.sortBy(commishTeams, function(fantasyTeam){ 
				return fantasyTeam.get("draftPosition"); 
			});
			
			var defaultOption = "<option value=\"\" selected=\"true\">Select One</option>";
			var unavailableOption = "<option value=\"\" selected=\"true\">No Teams Available</option>";
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			this.$("#joinLgInfoPickTmInput").empty();
			
			if(_.size(selectableTeams) > 1) {
				this.$("#joinLgInfoPickTmInput").append(defaultOption);
				_.each(selectableTeams, function(fantTeam){
					this.$("#joinLgInfoPickTmInput").append(optionStart 
							+ fantTeam.get("id")
							+ optionMiddle
							+ "Pick #"
							+ fantTeam.get("draftPosition")
							+ " - Team: "
							+ fantTeam.get("teamName")						
							+ optionEnd);
				});
			} else if(_.size(selectableTeams) == 1) {
				_.each(selectableTeams, function(fantTeam){
					this.$("#joinLgInfoPickTmInput").append(optionStart 
							+ fantTeam.get("id") 
							+ "\" selected=\"true"
							+ optionMiddle
							+ "Pick #"
							+ fantTeam.get("draftPosition")
							+ " - Team: "
							+ fantTeam.get("teamName")
							+ optionEnd);
				});
			} else {
				this.$("#joinLgInfoPickTmInput").append(unavailableOption);
			}
			
			this.$("#joinLgInfoPickTmInput").on("change", this.updateTeamTextInput);
		},
		
		updateTeamTextInput: function() {
			var team = this.leagueModel.getTeam(this.$("#joinLgInfoPickTmInput").val());
			if(team){
				this.$("#joinLgInfoTmNameInput").val(team.get('teamName'));
			}
		},
		
		success : function() {
			this.hideAll();
			
			var link = '/draftapp/dashboard/leagues/' + this.leagueModel.get('leagueId')+ '/instances/' + this.leagueModel.get('id');
			
			this.$("#joinLgSuccessLink").attr("href", link);
			this.$("#joinLgSuccessLink").html(this.leagueModel.prettyDispName());
			this.$("#joinLgSuccessGrp").show();
			$(this.el).show();
		},
		
		alreadyJoined : function() {
			this.hideAll();
			
			var link = '/draftapp/dashboard/leagues/' + this.leagueModel.get('leagueId')+ '/instances/' + this.leagueModel.get('id');
			
			this.$("#joinLgAlreadyJoinedLink").attr("href", link);
			this.$("#joinLgAlreadyJoinedLink").html(this.leagueModel.prettyDispName());
			this.$("#joinLgAlreadyJoinedGrp").show();
			$(this.el).show();
		},
		
		setLgModel : function(foundLg) {
			this.leagueModel = foundLg;
		},
		
		errorLeagueKey : function (errorCode) {
			this.$("#joinLgSearchKeyGrp").addClass("error");
			this.$("#joinLgSearchKeyInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#joinLgSearchKeyErrMsg").html("Join key is empty");
					this.$("#joinLgSearchKeyErrMsg").show();
					break;
				case "LENGTH":
					this.$("#joinLgSearchKeyErrMsg").html("Join key must be between 21 and 61 characters long");
					this.$("#joinLgSearchKeyErrMsg").show();
					break;
				case "ALPHANUM":
					this.$("#joinLgSearchKeyErrMsg").html("Join key may only contain alpha numeric characters");
					this.$("#joinLgSearchKeyErrMsg").show();
					break;
				case "LEAGUEDOESNTEXISTS": 
					this.$("#joinLgSearchKeyErrMsg").html("League doesn't exist for provided league join key");
					this.$("#joinLgSearchKeyErrMsg").show();
					break;
				case "CLOSED": 
				case "NOTACTIVE": 
					this.$("#joinLgSearchKeyErrMsg").html("There are no active leagues to join for the provided league join key");
					this.$("#joinLgSearchKeyErrMsg").show();
					break;
				default : 
					this.$("#joinLgSearchKeyErrMsg").html("Join key is invalid");
					this.$("#joinLgSearchKeyErrMsg").show();
			}
		},
		
		errorTeam : function (errorCode) {
			this.$("#joinLgInfoPickTmGrp").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#joinLgInfoPickTmErrMsg").html("Team is empty");
					this.$("#joinLgInfoPickTmErrMsg").show();
					break;
				default : 
					this.$("#joinLgInfoPickTmErrMsg").html("Team is invalid");
					this.$("#joinLgInfoPickTmErrMsg").show();
			}
		},
		
		errorTeamName : function (errorCode) {
			this.$("#joinLgInfoTmNameGrp").addClass("error");
			this.$("#joinLgInfoTmNameInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#joinLgInfoTmNameErrMsg").html("Team name is empty");
					this.$("#joinLgInfoTmNameErrMsg").show();
					break;
				case "LENGTH":
					this.$("#joinLgInfoTmNameErrMsg").html("Team name must be between 2 and 20 characters long");
					this.$("#joinLgInfoTmNameErrMsg").show();
					break;
				case "ALPHANUMSPACE":
					this.$("#joinLgInfoTmNameErrMsg").html("Team name may only contain alpha numeric characters and spaces");
					this.$("#joinLgInfoTmNameErrMsg").show();
					break;
				default : 
					this.$("#joinLgInfoTmNameErrMsg").html("Team name is invalid");
					this.$("#joinLgInfoTmNameErrMsg").show();
			}
		},
		
		errorLoginType : function (errorCode) {
			this.$("#joinLgLoginTypeGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#joinLgLoginTypeErrMsg").html("Sign In type is empty");
					this.$("#joinLgLoginTypeErrMsg").show();
					break;
				default : 
					this.$("#joinLgLoginTypeErrMsg").html("Sign In type is invalid");
			}
		},
		
		errorUsername : function (errorCode) {
			this.$("#joinLgLoginUserNameGrp").addClass("error");
			this.$("#joinLgLoginUserNameInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#joinLgLoginUserNameErrMsg").html("Username is empty");
					this.$("#joinLgLoginUserNameErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#joinLgLoginUserNameErrMsg").html("Username must be between 5 and 20 characters long");
					this.$("#joinLgLoginUserNameErrMsg").show();
					break;
				case "ALPHANUM": 
					this.$("#joinLgLoginUserNameErrMsg").html("Username may only contain alpha numeric characters");
					this.$("#joinLgLoginUserNameErrMsg").show();
					break;
				case "USEREXISTS": 
					this.$("#joinLgLoginUserNameErrMsg").html("User has already been created");
					this.$("#joinLgLoginUserNameErrMsg").show();
					break;
				case "NOTAUTH": 
					break;
				default : 
					this.$("#joinLgLoginUserNameErrMsg").html("Username is invalid");
			}
		},
		
		errorPassword : function (errorCode) {
			this.$("#joinLgLoginPassGrp").addClass("error");
			this.$("#joinLgLoginPassInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#joinLgLoginPassErrMsg").html("Password is empty");
					this.$("#joinLgLoginPassErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#joinLgLoginPassErrMsg").html("Password must be at least 5 characters long");
					this.$("#joinLgLoginPassErrMsg").show();
					break;
				case "SAME": 
					this.$("#joinLgLoginPassErrMsg").html("Password must not match the user name");
					this.$("#joinLgLoginPassErrMsg").show();
					break;
				case "NOTAUTH": 
					break;
				default : 
					this.$("#joinLgLoginPassErrMsg").html("Password is invalid");
			}
		},
		
		errorEmail: function(errorCode) {
			this.$("#joinLgLoginEmailGrp").addClass("error");
			this.$("#joinLgLoginEmailInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#joinLgLoginEmailErrMsg").html("Email is empty");
					this.$("#joinLgLoginEmailErrMsg").show();
					break;
				case "EMAIL": 
					this.$("#joinLgLoginEmailErrMsg").html("Invalid email address");
					this.$("#joinLgLoginEmailErrMsg").show();
					break;
				case "NOTEQUAL":
					this.$("#joinLgLoginEmailErrMsg").html("Email must match the confirmatin email address");
					this.$("#joinLgLoginEmailErrMsg").show();
					break;
				case "EMAILEXISTS":
					this.$("#joinLgLoginEmailErrMsg").html("Email has already been registered");
					this.$("#joinLgLoginEmailErrMsg").show();
					break;
				default : 
					this.$("#joinLgLoginEmailErrMsg").html("Invalid email address");
			}
		}
	});

	var JoinMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'alreadyInLeague', this.alreadyInLeague);
			this.listenTo(this.event, 'leagueClosed', this.leagueClosed);
			this.listenTo(this.event, 'success', this.success);
			
			this.listenTo(this.event, 'errorLogin', this.error);
			this.listenTo(this.event, 'errorSearchLg', this.error);
			this.listenTo(this.event, 'errorJoinLgInst', this.error);
			this.listenTo(this.event, 'errorLogin:notAuthorized', this.notAuthorized);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#joinLgBodyMessageError").hide();
			this.$("#joinLgBodyMessageLoginNotAuthorized").hide();
			this.$("#joinLgBodyMessageProcessing").hide();
			this.$("#joinLgBodyMessageAlreadyInLg").hide();
			this.$("#joinLgBodyMessageLeagueClosed").hide();
			this.$("#joinLgBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#joinLgBodyMessageError").show();
		},
		
		notAuthorized: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#joinLgBodyMessageLoginNotAuthorized").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#joinLgBodyMessageProcessing").show();
		},
		
		alreadyInLeague: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#joinLgBodyMessageAlreadyInLg").show();
		},
		
		leagueClosed: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#joinLgBodyMessageLeagueClosed").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#joinLgBodyMessageSuccess").show();
		}
	});
	
	var JoinView = Backbone.View.extend({
		el: $("#joinLgContent"),
		
		initialize: function(options) {
			this.userModel = options.userModel;
			this.leagueModel = options.leagueModel ? options.leagueModel : new LeagueInstanceModel();
			this.errorCode = options.errorCode;
			this.userLeagueCollection = options.userLeagueCollection;
			this.loginModel = new LoginModel();
			this.registerModel = new RegisterModel();
			this.searchLgModel = new SearchLeagueModel();
			this.joinLgModel = new JoinLeagueInstanceModel();
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'loginSuccessCallback');
			_.bindAll(this, 'searchSuccessCallback');
			
			this.message = new JoinMessageView({el: this.$("#joinLgBodyMessage"), event: this.event});
			this.content = new JoinContentView({
				el: this.$("#joinLgBodyContent"), 
				event: this.event ,
				userModel: this.userModel,
				leagueModel: this.leagueModel,
				loginModel: this.loginModel,
				registerModel: this.registerModel,
				searchLgModel: this.searchLgModel,
				joinLgModel: this.joinLgModel,
				submittedData: this.submittedData});
			this.footer = new JoinFooterView({el: this.$("#joinLgFooter"), userModel: this.userModel, event: this.event});
			
			this.listenTo(this.event, 'savingJoinSuccess', this.joinSuccess);
			this.listenTo(this.event, 'savingJoinError', this.joinError);
			this.listenTo(this.event, 'savingSearchSuccess', this.searchSuccess);
			this.listenTo(this.event, 'savingSearchError', this.searchError);
			this.listenTo(this.event, 'savingLoginSuccess', this.loginSuccess);
			this.listenTo(this.event, 'savingLoginError', this.loginError);
		},
		
		render: function () {
			if(this.errorCode == 'NOTFOUND'){
				this.event.trigger("errorSearchLg");
				this.event.trigger("errorSearchLg:key", "LEAGUEDOESNTEXISTS");
			} else if(this.errorCode == 'CLOSED'){
				this.event.trigger("leagueClosed");
				this.event.trigger("errorSearchLg:key", "CLOSED");
			} else if(this.errorCode == 'ERROR'){
				this.event.trigger("errorSearchLg");
				this.event.trigger("errorSearchLg:key", "INVALID");
			} else {
				if(!this.userModel.isGuest() && !this.leagueModel.isNew() && this.leagueModel.getLeagueUser(this.userModel.get('userName'))){
					this.event.trigger("alreadyInLeague");
				} else {
					this.event.trigger("default");
				}				
			}
			
			return this;
		},
		
		joinError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("errorJoinLgInst");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("errorJoinLgInst:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("errorJoinLgInst");
				}
				
				this.submittedData.isSubmitted = false;
			}
		}, 
		
		joinSuccess: function () {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				
				this.event.trigger("success");
				this.userLeagueCollection.fetch();
			}
			return this;
		},
		
		searchError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("errorSearchLg");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("errorSearchLg:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if (error.status == 404) {
					//League doesn't exist
					this.event.trigger("errorSearchLg");
					this.event.trigger("errorSearchLg:key", "LEAGUEDOESNTEXISTS");
				} else if (error.status == 409) {
					//League doesn't exist
					this.event.trigger("leagueClosed");
					this.event.trigger("errorSearchLg:key", "CLOSED");
				} else {
					this.event.trigger("errorSearchLg");
				}
				
				this.submittedData.isSubmitted = false;
			}
		}, 
		
		searchSuccess: function () {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				
				var lgObj = {
					id : this.searchLgModel.get('id'),
					leagueId : this.searchLgModel.get('leagueId')
				};
				
				var foundLg = LeagueInstanceModel.findOrCreate(lgObj, {merge : false, create: false});
				
				if(!foundLg){
					this.leagueModel.set('id', this.searchLgModel.get('id'));
					this.leagueModel.set('leagueId', this.searchLgModel.get('leagueId'));
					
				} else {
					//Update league model reference
					this.leagueModel = foundLg;
					this.content.setLgModel(foundLg);
				}	
				
				this.leagueModel.fetch({success: this.searchSuccessCallback});
			}
			return this;
		},
		
		searchSuccessCallback: function(model, response) {
			if(this.leagueModel.getLeagueUser(this.userModel.get('userName'))){
				this.event.trigger("alreadyInLeague");
			} else {
				this.event.trigger("default");
			}
		},
		
		loginError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("errorLogin");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("errorLogin:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if (error.status == 401) {
					//Username/pass invalid
					this.event.trigger("errorLogin:notAuthorized");
					this.event.trigger("errorLogin:username", "NOTAUTH");
					this.event.trigger("errorLogin:password", "NOTAUTH");
				} else if (error.status == 409) {
					//Email already registered
					this.event.trigger("errorLogin");
					
					var errObj = JSON.parse(error.responseText);			
					if(errObj.message && errObj.message.toLowerCase().indexOf("email") > -1){
						//Email already activated
						this.event.trigger("errorLogin:email", "EMAILEXISTS");
					} else if(errObj.message && errObj.message.toLowerCase().indexOf("user") > -1) {
						//User already activated
						this.event.trigger("errorLogin:username", "USEREXISTS");
					}
				} else {
					this.event.trigger("errorLogin");
				}
				
				this.submittedData.isSubmitted = false;
			}
		}, 
		
		loginSuccess: function () {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				
				if (this.$("input[name='joinLgLoginType']:checked").val() == 'LOGIN') {
					this.userModel.set({userName: this.loginModel.get('userName').toLowerCase()});
				} else if (this.$("input[name='joinLgLoginType']:checked").val() == 'REGISTER') {
					this.userModel.set({userName: this.registerModel.get('userName').toLowerCase()});
				}
				
				this.userModel.fetch({success: this.loginSuccessCallback});
			}
			return this;
		},
		
		loginSuccessCallback: function(model, response) {
			this.$("#joinLgLoginUserNameInput").val('');
			this.$("#joinLgLoginPassInput").val('');
			this.$("#joinLgLoginEmailInput").val('');
			
			if(!this.leagueModel.isNew() && this.leagueModel.getLeagueUser(this.userModel.get('userName'))){
				this.event.trigger("alreadyInLeague");
			} else {
				this.event.trigger("save");
			}			
		}
	});
	
	return JoinView;  
});